import React from 'react';
import PropTypes from 'prop-types';
import { ShareEstimateModal } from '../ShareEstimate';
import ShareIcon from '../../themes/svg/shareIcon';

const ShareIconButton = ({ sharedEmail, shareModal }) => {
  if (sharedEmail !== null) return <ShareEstimateModal />;
  return (
    <div className="action" >
      <div
        className="save"
        tabIndex="-1"
        role="button"
        onClick={() => shareModal(0)}
      >
        <ShareIcon />{' '}
        <span id="saveEstimateButton" className="actionText">
          Share
        </span>
      </div>
      <ShareEstimateModal />
    </div>
  );
};


ShareIconButton.propTypes = {
  sharedEmail: PropTypes.string,
  shareModal: PropTypes.func.isRequired,
};

ShareIconButton.defaultProps = {
  sharedEmail: null,
};

export default ShareIconButton;
